import React, { useState } from "react";
import "./faq.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqData = [
    {
      question: "How does AI Aviator work?",
      answer:
        "AI Aviator uses computer vision and AI to recognize UI elements, navigate screens, and perform automated actions.",
    },
    {
      question: "Which platforms does AI Aviator support?",
      answer:
        "It works across Windows, macOS, and web-based applications, making it suitable for diverse industries.",
    },
    {
      question: "Do I need coding skills to use AI Aviator?",
      answer:
        "No, AI Aviator is a no-code solution designed for both technical and non-technical users.",
    },
    {
      question: "Can AI Aviator adapt to UI changes?",
      answer:
        "Yes, AI Aviator dynamically adjusts to minor UI modifications, minimizing script maintenance.",
    },
    {
      question: "Is AI Aviator secure for enterprise use?",
      answer:
        "Yes, AI Aviator follows enterprise security standards and ensures data privacy and compliance.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  return (
    <section
      className={`faq-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="six"
    >
      <div className="container">
        <div className="section-wrapper faq-section-wrapper">
          <div className="section-heading">
            <div className="heading-tag">
              <span>FAQ</span>
            </div>
            <div className="heading-description">
              <h2>Everything You Need to Know </h2>
            </div>
          </div>
        </div>
        <div className="accordion">
          {faqData.map((item, index) => (
            <div className="accordion-item" key={index}>
              <button
                id={`accordion-button-${index + 1}`}
                aria-expanded={activeIndex === index ? "true" : "false"}
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-title">{item.question}</span>
                <span className="icon" aria-hidden="true"></span>
              </button>
              <div className="accordion-content">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
